import Container from "Components/Container/Container";
import React, { useState, useEffect, useRef } from "react";

const Vision = ({ data }) => {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setVisible(true);
        } else {
          setVisible(false);
        }
      });
    }, options);

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const imageStyles = [
    "absolute top-32 left-44 w-[36rem] z-[1] transition-transform duration-700 ease-in-out",
    "absolute top-52 right-24 w-[34rem] z-[0] transition-transform duration-700 ease-in-out delay-200",
    "absolute bottom-32 left-10 w-[38rem] z-[0] transition-transform duration-700 ease-in-out delay-200",
    "absolute bottom-20 right-64 w-[24rem] z-[0] transition-transform duration-700 ease-in-out",
  ];

  return (
    <section
      ref={sectionRef}
      className="scroll-section h-[80vh] relative overflow-hidden"
    >
      <Container className="h-full flex items-center justify-center relative">
        {/* Content */}
        <div className="lg:w-1/2 py-16 lg:py-32 px-6 lg:px-10 text-white flex flex-col items-center relative justify-center bg-[#000000a6] relative z-[2]">
          <h2 className="text-white text-5xl lg:text-6xl text-font bebas">
            {data?.title}
          </h2>
          <p className="text-xl text-center mt-2">{data?.sub_title}</p>
        </div>

        {/* Images */}
        {data?.images?.slice(0, 4).map((src, index) => (
          <img
            key={index}
            src={src}
            className={`${imageStyles[index]} ${
              visible
                ? "translate-x-0 opacity-100 scale-1"
                : index % 2 === 0
                ? "-translate-x-full opacity-0 scale-[0.6]"
                : "translate-y-full opacity-0 scale-[0.6]"
            }`}
            alt=""
          />
        ))}
      </Container>
    </section>
  );
};

export default Vision;
